module.exports = __webpack_public_path__ + "img/follow-house.51d62ff4.png";